import React, { useState, useEffect } from "react";
import { Button } from "./button";
import { Input } from "./input";

export const EditCollectionModal = ({
  open,
  onClose,
  onSave,
  collection = null,
  isLoading = false,
}) => {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (collection && open) {
      setName(collection.name || "");
      setDescription(collection.description || "");
    }
  }, [collection, open]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim()) {
      return; // Name is required
    }
    onSave && onSave({ name: name.trim(), description: description.trim() });
  };

  const handleClose = () => {
    setName("");
    setDescription("");
    onClose();
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
      <div className="bg-white rounded-lg p-6 w-full max-w-md shadow-xl">
        <h3 className="text-lg font-semibold mb-4">Edit Collection</h3>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Name *
            </label>
            <Input
              className="w-full"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Collection name..."
              required
              disabled={isLoading}
            />
          </div>
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Description
            </label>
            <Input
              className="w-full"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Collection description..."
              disabled={isLoading}
            />
          </div>
          <div className="flex justify-end gap-2">
            <Button
              type="button"
              variant="outline"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="bg-blue-500 text-white"
              disabled={isLoading || !name.trim()}
            >
              {isLoading ? "Updating..." : "Save"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
};
